import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { useState, useEffect } from 'react';
export const FadeSlideUpContainer = (props) => {
    const { delay, animate } = props;
    const [shown, setShown] = useState(false);
    const [views, setViews] = useState(0);
    useEffect(() => {
        if (animate) {
            setViews(views + 1);
            if (views < 1) {
                const timeout = setTimeout(() => setShown(true), delay);
                return () => clearTimeout(timeout);
            }
            setShown(true);
        }
        else {
            setShown(false);
        }
    }, [animate]);
    return (_jsx("div", { className: classnames('fade-slide-up-container', { 'slide-up': shown && views === 1 }, { 'fade': (shown && views > 1) }), children: props.children }));
};
